import { OrderItem } from 'src/admin-entity/interface/order/order-item.interface';
import { dateFormatter } from 'src/utils/dateFormatter';

export interface OrderInitType {
    startDate: string;
    endDate: string;
    searchTopic: string;
    searchToken: string;
    productName: string;
    allSearchPhone: string;
    allSearchName: string;
    distributorName: string;
    blacklistGrade: string;
    paymentMethodType: string[];
    orderItemProductStatus: string[];
    page: number;
    take: number;
    searchResult: {
        page: {
            count: number;
        };
        orderItems: OrderItem[];
    };
    isWithdrawModalOpen: boolean;
    isWithdrawModalOpenOld: boolean;
    withdrawOrderItem: OrderItem;
}

export const orderInitState: OrderInitType = {
    startDate: dateFormatter(new Date(new Date().getFullYear(), new Date().getMonth(), 1), 'yyyy-MM-DD'),
    endDate: dateFormatter(new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0), 'yyyy-MM-DD'),
    allSearchName: '',
    allSearchPhone: '',
    distributorName: '',
    productName: '',
    searchTopic: 'orderItemKey',
    searchToken: '',
    blacklistGrade: '',
    paymentMethodType: [],
    orderItemProductStatus: [],
    page: 0,
    take: 100,
    searchResult: {
        orderItems: [],
        page: {
            count: 0,
        },
    },
    isWithdrawModalOpen: false,
    isWithdrawModalOpenOld: false,
    withdrawOrderItem: undefined,
};
